import { Address, Identity, OrderLine } from '@/classes/models'

export default class Order {
  /**
   * Create new order and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)

    // Map billing identity to Identity
    if (typeof this.billingIdentity !== 'undefined') {
      this.billingIdentity = new Identity(this.billingIdentity)
    }

    // Map billing identity to Identity
    if (typeof this.billingAddress !== 'undefined') {
      this.billingAddress = new Address(this.billingAddress)
    }

    // Map billing identity to Identity
    if (typeof this.shippingAddress !== 'undefined') {
      this.shippingAddress = new Address(this.shippingAddress)
    }

    if (typeof this.orderLines !== 'undefined') {
      this.orderLines = this.orderLines.map(orderLine => { return new OrderLine(orderLine) })
    }
  }
}
